export default __webpack_public_path__ + "2d00b524412566eabca3bfdd3e555a92.png";